import React, { ComponentProps, ForwardedRef, forwardRef, PropsWithChildren } from 'react'

import { bemJoin } from 'bem-join'
import classnames from 'classnames'

import './Card.scss'

const b = bemJoin('lawyer-card')

export type CardProps = ComponentProps<'div'>

export const Card = forwardRef(
  (
    { className, children, ...rest }: PropsWithChildren<CardProps>,
    forwardedRef: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <div ref={forwardedRef} className={classnames(b(), className)} {...rest}>
        {children}
      </div>
    )
  }
)
